package com.neurobs.react.semanticui

import com.neurobs.react.ReactUtil
import slinky.core.facade.ReactElement
import slinky.web.html._

object UiContainerFactory {

  private def TemplateSegment(children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("segment"),
      style := uiElementModifiers.createStyle
    )(
      children:_*
    )
  }

  def Segment(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateSegment(children)(uiElementModifiers)
  }
}
